import { useEffect, useRef, useState } from 'react';

const FADE_MS = 500;

// Slides in at the bottom of the screen, then fades out after `duration` ms
// (or when clicked) and calls onDone so the parent can unmount it. Removal is
// timer-based rather than transitionend, so it still goes away in hidden tabs
// or with reduced motion.
export default function Toast({ children, duration = 5000, onDone }) {
  const [leaving, setLeaving] = useState(false);
  // The parent re-renders every tick; keep the latest callback without restarting timers.
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    const timer = leaving
      ? setTimeout(() => onDoneRef.current(), FADE_MS)
      : setTimeout(() => setLeaving(true), duration);
    return () => clearTimeout(timer);
  }, [leaving, duration]);

  return (
    <div className="fixed inset-x-0 lg:right-96 bottom-6 z-50 flex justify-center px-4 pointer-events-none">
      <div
        role="status"
        aria-live="polite"
        onClick={() => setLeaving(true)}
        className={`cursor-pointer rounded-lg bg-oxford-blue px-5 py-3 text-sm text-white shadow-xl
          animate-toast-in transition duration-500 ${leaving ? 'opacity-0 translate-y-4' : 'opacity-100 pointer-events-auto'}`}>
        {children}
      </div>
    </div>
  );
}
